import { Instance, SnapshotOut, types } from "mobx-state-tree"

/**
 * 訂單
 */
export const OrderBaseModel = types
  .model("Order")
  .props({
    order_no: types.maybe(types.identifier),
    id: types.maybe(types.number),
    quantities: types.maybe(types.number),
    stock: types.maybe(types.number),
    amount: types.maybe(types.number),
    min_trading: types.maybe(types.number),
    max_trading: types.maybe(types.number),
    payment_methods: types.optional(types.array(types.number), []),
    user_id: types.maybe(types.number),
    username: types.maybe(types.string),
    name: types.maybe(types.string),
    credit_score: types.maybe(types.number),
    order_num: types.maybe(types.number),
    settled_count: types.maybe(types.number),
    created: types.maybe(types.Date),
    status: types.maybe(types.number),
    avatar: types.maybe(types.string),
  })
  .actions((self) => ({
    update(values: { [key: string]: any }) {
      for (const key in values) {
        self[key] = values[key]
      }
    },
  }))
export const OrderModel = types.snapshotProcessor(OrderBaseModel, {
  // from snapshot to instance
  preProcessor(sn: SnapshotOut<typeof OrderBaseModel>) {
    return {
      ...sn,
      created: new Date(sn.created).valueOf(),
    }
  },
  postProcessor(sn) {
    return sn
  },
})

type OrderType = Instance<typeof OrderModel>
export interface Order extends OrderType {}
type OrderSnapshotType = SnapshotOut<typeof OrderModel>
export interface OrderSnapshot extends OrderSnapshotType {}
